<!-- Spinner -->
<div class="overlay-content" *ngIf="isLoading$ | async">
  <p-progressSpinner></p-progressSpinner>
</div>
<!-- Spinner -->
